/// <reference path="_references.ts"/>

module App.TimeEvent {
	angular
		.module('timeEvent', [])
		.controller('TimeEventEditController', TimeEventEditController)
		.controller('TimeEventViewController', TimeEventViewController)
		.service('TimeEventService', TimeEventService);
}